import { render, staticRenderFns } from "./Authorizations.vue?vue&type=template&id=5349f151&scoped=true"
import script from "./Authorizations.vue?vue&type=script&lang=js"
export * from "./Authorizations.vue?vue&type=script&lang=js"
import style0 from "./Authorizations.vue?vue&type=style&index=0&id=5349f151&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5349f151",
  null
  
)

export default component.exports